var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns is-mobile is-centered"},[_c('div',{staticClass:"column is-4"},[_c('h1',{staticClass:"title mb-2"},[_vm._v(_vm._s(_vm.$t('user.login')))]),_c('SignForm',{attrs:{"action":"login"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }